export class IdpGroup {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "idpId",
            "baseName": "idpId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "providerGroupId",
            "baseName": "providerGroupId",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleIds",
            "baseName": "roleIds",
            "type": "Array<string>",
            "format": "uuid"
        }
    ];
    static getAttributeTypeMap() {
        return IdpGroup.attributeTypeMap;
    }
    constructor() {
    }
}
